/* eslint-disable promise/param-names */
const state = {
  gridOnline:{
      url: '',
      title: '',
      columns: {},
      show: false,
      export_csv: true,
      titleHelp: '',
      txtHelp: '',
  }
}

const getters = {
  gridOnline: state => state.gridOnline,
}

const mutations = {
    changeGridOnline(state, payload){
        state.gridOnline = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/gridOnline.js